module.exports = __webpack_public_path__ + "static/media/alicebanner.ff5d5a26.png";